import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-vendortaken',
  templateUrl: './vendortaken.component.html',
  styleUrls: ['./vendortaken.component.css']
})
export class VendortakenComponent implements OnInit {

  constructor(
    public router: Router,
    public dialogRef: MatDialogRef<VendortakenComponent>,
  ) { }

  ngOnInit(): void {
  }
  onNoClick(): void {
    this.dialogRef.close();
    this.router.navigate(['/vendors']);
  }

}
